import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative py-5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "absolute inset-0 flex items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-full border-b-2 dark:border-b-gray-700 rounded-lg" })
], -1)
const _hoisted_3 = { class: "relative flex justify-center" }
const _hoisted_4 = { class: "bg-white text-gray-400 dark:bg-gray-900 dark:text-gray-700 px-4 text-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.title), 1)
    ])
  ]))
}